@let shopSettings = shopSettings$ | async;
@let isDeviceMobile = isDeviceMobile$ | async;

<div [class]="classes?.cartViewType" [class.mobileViewCart]="isDeviceMobile">
    <div class="cart-items" [class]="classes?.cartStyle">
        @for (item of items; track item) {
            <div class="item" [class.mobileViewCartItem]="isDeviceMobile">
                <div class="item-info">
                    <div class="item-info-photo">
                        <img
                            [src]="getProductImageSrc(item)"
                            [spFallbackImage]="getProductImageFallbackSrc(item)"
                            [alt]="item.name"
                        />
                    </div>
                    <div class="item-info-text">
                        <h3>{{ item.name }}</h3>
                        <!--                    <div class="parameters" *ngFor="let section of item.sections;">-->
                        <!--                        <label>{{ section.name }}</label>-->
                        <!--                        <ng-container *ngFor="let param of section.parameters">-->
                        <!--                            <p>-->
                        <!--                                <span class="param-prop">-->
                        <!--                                    {{ param.parameter }}<span *ngIf="param.value">:</span>-->
                        <!--                                </span>-->
                        <!--                                <span class="param-value">-->
                        <!--                                    {{ param.value }}-->
                        <!--                                </span>-->
                        <!--                            </p>-->
                        <!--                        </ng-container>-->
                        <!--                    </div>-->
                    </div>
                </div>
                <div class="item-price">
                    <div class="card-product-counter">
                        <button class="counter-control">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="10"
                                viewBox="0 0 10 10"
                                fill="none"
                            >
                                <rect y="4" width="10" height="2" rx="1" fill="currentColor" />
                            </svg>
                        </button>
                        <input class="quantity-control" [value]="1" type="number" />
                        <button class="counter-control">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="10"
                                viewBox="0 0 10 10"
                                fill="none"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M4 9C4 9.55228 4.44772 10 5 10C5.55228 10 6 9.55228 6 9V6H9C9.55229 6 10 5.55228 10 5C10 4.44772 9.55228 4 9 4H6V1C6 0.447715 5.55228 0 5 0C4.44772 0 4 0.447716 4 1V4H1C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6H4V9Z"
                                    fill="currentColor"
                                />
                            </svg>
                        </button>
                    </div>
                    <div class="price">
                        <span>{{ +item.price * item.quantity | number: "1.2-2" }} {{ shopSettings?.currency }}</span>
                    </div>
                </div>
                <div class="close-icon">×</div>
            </div>
        }
        @if (hasPricedDeliveryVariant(shopSettings?.delivery_variants)) {
            <div class="total-price">
                <p>{{ "delivery" | translate }}: 0 {{ shopSettings?.currency }}</p>
            </div>
        }
        <div class="total-price">
            <p>
                {{ "shop_cart_total_price" | translate }}: {{ getTotalPrice() | number: "1.2-2" }}
                {{ shopSettings?.currency }}
            </p>
        </div>
    </div>
    <div [class]="classes?.cartFormWrapper" class="cart-form-wrapper">
        <div [class]="classes?.form" class="cart-form" [id]="getWidgetId">
            <form [class]="classes?.formContainer" style="pointer-events: none">
                <div [class]="classes?.formFieldsContainer">
                    @for (control of elements; track trackByElementIndex(index); let index = $index) {
                        @if (control.type !== formInputType.hidden) {
                            <div [class]="classes?.formField">
                                @switch (true) {
                                    @case (typeGuards.isInput(control)) {
                                        @if (inputSettings.showLabels) {
                                            <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                        }
                                        @if (!control.isDynamicPlaceholderEnabled && control.type !== "file") {
                                            <input
                                                [class]="classes?.formControl"
                                                [attr.type]="control.htmlInputType"
                                                [attr.placeholder]="control.placeholder"
                                            />
                                        }
                                        @if (control.type === "phone" && control.isDynamicPlaceholderEnabled) {
                                            <ngx-intl-tel-input
                                                [class]="'intl-size-' + inputSettings.inputSize"
                                                [cssClass]="classes?.formControl"
                                                [enableAutoCountrySelect]="true"
                                                [selectFirstCountry]="false"
                                                [separateDialCode]="true"
                                                [enablePlaceholder]="true"
                                                [searchCountryFlag]="true"
                                                [phoneValidation]="true"
                                                [searchCountryField]="[SearchCountryField.All]"
                                                [excludeCountries]="excludeCountries"
                                                [selectedCountryISO]="CountryISO"
                                                [numberFormat]="PhoneNumberFormat.International"
                                            >
                                            </ngx-intl-tel-input>
                                        }
                                        @if (control.type === "file") {
                                            <div class="ngx-dropzone-file">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                >
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M3 11C3.55228 11 4 11.4477 4 12V17C4 18.6568 5.34315 20 7 20H17C18.6568 20 20 18.6568 20 17V12C20 11.4477 20.4477 11 21 11C21.5523 11 22 11.4477 22 12V17C22 19.7614 19.7614 22 17 22H7C4.23857 22 2 19.7614 2 17V12C2 11.4477 2.44772 11 3 11Z"
                                                        fill="#3A83A2"
                                                    />
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M11.4001 3.2C11.7556 2.93333 12.2445 2.93333 12.6001 3.2L16.6001 6.2C17.0419 6.53137 17.1314 7.15817 16.8001 7.6C16.4687 8.04183 15.8419 8.13137 15.4001 7.8L13.0001 6V15C13.0001 15.5523 12.5523 16 12.0001 16C11.4478 16 11.0001 15.5523 11.0001 15V6L8.60006 7.8C8.15823 8.13137 7.53143 8.04183 7.20006 7.6C6.86869 7.15817 6.95823 6.53137 7.40006 6.2L11.4001 3.2Z"
                                                        fill="#3A83A2"
                                                    />
                                                </svg>
                                                <p>{{ control.placeholder | translate }}</p>
                                            </div>
                                        }
                                    }
                                    @case (typeGuards.isTextarea(control)) {
                                        @if (inputSettings.showLabels) {
                                            <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                        }
                                        <textarea
                                            [class]="classes?.formControlTextarea"
                                            [attr.placeholder]="control.placeholder"
                                        ></textarea>
                                    }
                                    @case (typeGuards.isCheckbox(control)) {
                                        <label class="sp-checkbox">
                                            <input [class]="classes?.spCheckbox" [attr.type]="control.htmlInputType" />
                                            @if (control.required) {
                                                <span
                                                    class="checkbox-text"
                                                    [innerHTML]="' ' + (control.label | removePTags) + ' *'"
                                                ></span>
                                            }
                                            @if (!control.required) {
                                                <span
                                                    class="checkbox-text"
                                                    [innerHTML]="' ' + (control.label | removePTags)"
                                                ></span>
                                            }
                                        </label>
                                    }
                                    @case (typeGuards.isRadio(control)) {
                                        @if (inputSettings.showLabels) {
                                            <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                        }
                                        @for (option of control.options; track option) {
                                            <div class="radio-options">
                                                <label>
                                                    <input
                                                        [class]="classes?.spRadio"
                                                        [attr.type]="control.htmlInputType"
                                                        [value]="option.value"
                                                        [checked]="option.selected"
                                                    />
                                                    <span class="radio-text"> {{ option.label }}</span>
                                                </label>
                                            </div>
                                        }
                                    }
                                    @case (typeGuards.isSelect(control)) {
                                        @if (inputSettings.showLabels) {
                                            <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                        }
                                        <select [class]="classes?.formControl">
                                            <option [ngValue]="null" [selected]="getSelected(control.options)" disabled>
                                                {{ "select_value" | translate }}
                                            </option>
                                            @for (option of control.options; track option) {
                                                <option [value]="option.value" [selected]="option.selected">
                                                    {{ option.label }}
                                                </option>
                                            }
                                        </select>
                                    }
                                }
                            </div>
                        }
                    }
                    @if (shopSettings?.delivery_variants?.length) {
                        <div [class]="classes?.formField">
                            <label>{{ "delivery_variants" | translate }} *</label>
                            @for (delivery of shopSettings?.delivery_variants; track delivery; let i = $index) {
                                <div class="delivery-option">
                                    <label class="delivery-label-option">
                                        <input
                                            [class]="classes?.spRadio"
                                            type="radio"
                                            [value]="delivery.price"
                                            formControlName="delivery"
                                        />
                                        <div class="delivery-info-wrapper">
                                            <p class="delivery-text">
                                                {{ delivery.name }}
                                                @if (delivery?.currentDeliveryValueState !== 1) {
                                                    <span>- {{ delivery.price | number: "1.2-2" }}</span>
                                                }
                                                @if (delivery?.currentDeliveryValueState !== 1) {
                                                    <span>{{ shopSettings?.currency }}</span>
                                                }
                                                @if (delivery?.currentDeliveryValueState === 1) {
                                                    <span> - {{ delivery.message }} </span>
                                                }
                                            </p>
                                            <p class="delivery-text-small">
                                                {{ delivery.description }}
                                            </p>
                                        </div>
                                    </label>
                                </div>
                            }
                        </div>
                    }
                    @if (paymentElements.length > 1) {
                        <div [class]="classes?.formField">
                            @if (inputSettings.showLabels) {
                                <label>{{ "payment_method" | translate }}</label>
                            }
                            <button [class]="classes?.formDropdownButton">
                                <div>
                                    <img
                                        [src]="getPaymentIconSrc(paymentElements[0].type)"
                                        [alt]="paymentElements[0].type"
                                    />
                                    <span>{{ getPaymentElementLabel(paymentElements[0].type, 0) | translate }}</span>
                                </div>
                                <span class="caret"></span>
                            </button>
                        </div>
                    }
                    @if (isPromoCodeEnabled) {
                        <div [class]="classes?.formField">
                            @if (inputSettings.showLabels) {
                                <label>{{ promoCodeLabel | translate }}</label>
                            }
                            <input
                                [class]="classes?.formControl"
                                type="text"
                                [placeholder]="promoCodePlaceholder | translate"
                            />
                        </div>
                    }
                    <div [class]="classes?.buttonWrapper">
                        <a [class]="getButtonStyles(formButtonSettings)">
                            @if (formButtonSettings.buttonIcon?.isActive) {
                                <span class="icon" [innerHTML]="getIcon(formButtonSettings.buttonIcon?.icon)"></span>
                            }
                            {{ formButtonSettings.label }}
                        </a>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
